import { LoadingIndicator } from "@indietabletop/appkit";
import { ViewContent } from "../oss/Layout/Layout.tsx";
import * as css from "./style.css.ts";

export function LoadingView() {
  return (
    <ViewContent isCentered inlineVariant="narrow">
      <div className={css.root}>
        <LoadingIndicator />
      </div>
    </ViewContent>
  );
}
